const urlRoute = window.location.pathname

export function locationMaintenance() {
  return urlRoute.includes("/paused/")
}
